import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';

const ContactHero = () => {
  return (
    <section className="relative h-[60vh] flex items-center overflow-hidden bg-white pt-20">
      <div className="absolute inset-0 z-0">
        <motion.div
          initial={{ scale: 1.05, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
          className="w-full h-full"
        >
          <Image 
            src="/assets/images/about-us-banner.jpg" 
            alt="VASTECH Consultation" 
            className="w-full h-full object-cover object-right grayscale opacity-10"
          />
        </motion.div>
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/80 to-transparent z-10"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-20">
        <div className="max-w-3xl">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="flex items-center space-x-3 text-[#91756A] mb-8"
          >
            <div className="w-12 h-[2px] bg-[#91756A]"></div>
            <span className="text-xs font-bold uppercase tracking-[0.4em]">Connect With Us</span>
          </motion.div>
          
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 1 }}
            className="text-5xl md:text-7xl lg:text-8xl font-bold text-[#4D4C4A] leading-[1.05] mb-10 tracking-tighter italic uppercase"
          >
            GET EXPERT <br />
            <span className="text-[#91756A]">CONSULTATION</span>
          </motion.h1>
          
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: "100px" }}
            transition={{ delay: 1, duration: 0.8 }}
            className="h-1 bg-[#91756A] mb-10"
          ></motion.div>
          
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.2, duration: 0.8 }}
            className="text-[#4D4C4A]/70 text-lg md:text-xl uppercase tracking-[0.2em] font-light max-w-lg leading-relaxed italic"
          >
            Professional support for elevator and climate control solutions.
          </motion.p>
        </div>
      </div>

      <div className="absolute left-1/2 bottom-0 w-px h-24 bg-gradient-to-b from-transparent to-[#91756A] z-20"></div>
    </section>
  );
};

export default ContactHero;